export default "__VITE_ASSET__C3IF4xel__"